<div class="view-header flex-header">
  <div class="view-header-left">
    <h1 class="view-title">Job Management</h1>
    <p class="view-subtitle">{{ total || 0 }} total jobs</p>
  </div>
  <button class="primary-btn" (click)="navigateToCreateJob()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
    Create Job
  </button>
</div>

<div class="filters-bar" *ngIf="allPostJobs.length > 0 || hasActiveFilters()">   
      <div class="search-input-group">
    <i class="bi bi-search search-icon"></i>
    <input
      type="text"
      [(ngModel)]="jobSearchQuery"
      (input)="onSearchChange()"
      placeholder="Search jobs..."
    />
    <button
      *ngIf="jobSearchQuery"
      class="clear-search-btn"
      type="button"
      (click)="clearSearch()">
      <i class="bi bi-x"></i>
    </button>
      </div>

      <div class="dropdowns-group">
        <!-- Custom Dropdown 1: Status -->
        <div class="custom-dropdown-container">
          <button
            class="custom-dropdown-toggle-btn"
            (click)="toggleStatusDropdown($event)"
          >
            <span class="btn-text-content">{{
              selectedJobStatus || "All Status"
            }}</span>
            <svg
              class="dropdown-chevron"
              [class.rotated]="isStatusDropdownOpen"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </button>

          <div
            class="custom-dropdown-menu"
            *ngIf="isStatusDropdownOpen"
            (click)="$event.stopPropagation()"
          >
            <div
              class="menu-option-item"
              [class.selected]="selectedJobStatus === ''"
              (click)="selectStatus('')"
            >
              <svg
                class="check-icon"
                *ngIf="selectedJobStatus === ''"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              All Status
            </div>
            <div
              class="menu-option-item"
              [class.selected]="selectedJobStatus === 'Active'"
              (click)="selectStatus('Active')"
            >
              <svg
                class="check-icon"
                *ngIf="selectedJobStatus === 'Active'"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Active
            </div>
            <div
              class="menu-option-item"
              [class.selected]="selectedJobStatus === 'Closed'"
              (click)="selectStatus('Closed')"
            >
              <svg
                class="check-icon"
                *ngIf="selectedJobStatus === 'Closed'"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Closed
            </div>
            <div
              class="menu-option-item"
              [class.selected]="selectedJobStatus === 'Pending'"
              (click)="selectStatus('Pending')"
            >
              <svg
                class="check-icon"
                *ngIf="selectedJobStatus === 'Pending'"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Pending
            </div>
            <div
              class="menu-option-item"
              [class.selected]="selectedJobStatus === 'Draft'"
              (click)="selectStatus('Draft')"
            >
              <svg
                class="check-icon"
                *ngIf="selectedJobStatus === 'Draft'"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Draft
            </div>
          </div>
        </div>

        <!-- Custom Dropdown 2: Type -->
        <div class="custom-dropdown-container">
          <button
            class="custom-dropdown-toggle-btn"
            (click)="toggleTypeDropdown($event)"
          >
            <span class="btn-text-content">{{
              selectedJobType || "All Types"
            }}</span>
            <svg
              class="dropdown-chevron"
              [class.rotated]="isTypeDropdownOpen"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </button>

          <div
            class="custom-dropdown-menu"
            *ngIf="isTypeDropdownOpen"
            (click)="$event.stopPropagation()"
          >
            <div
              class="menu-option-item"
              [class.selected]="selectedJobType === ''"
              (click)="selectType('')"
            >
              <svg
                class="check-icon"
                *ngIf="selectedJobType === ''"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              All Types
            </div>
            <div
              class="menu-option-item"
              [class.selected]="selectedJobType === 'Full-Time'"
              (click)="selectType('Full-Time')"
            >
              <svg
                class="check-icon"
                *ngIf="selectedJobType === 'Full-Time'"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Full-Time
            </div>
            <div
              class="menu-option-item"
              [class.selected]="selectedJobType === 'Part-Time'"
              (click)="selectType('Part-Time')"
            >
              <svg
                class="check-icon"
                *ngIf="selectedJobType === 'Part-Time'"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Part-Time
            </div>
            <div
              class="menu-option-item"
              [class.selected]="selectedJobType === 'Internship/Training'"
              (click)="selectType('Internship/Training')"
            >
              <svg
                class="check-icon"
                *ngIf="selectedJobType === 'Internship/Training'"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Internship/Training
            </div>
            <div
              class="menu-option-item"
              [class.selected]="selectedJobType === 'Contract'"
              (click)="selectType('Contract')"
            >
              <svg
                class="check-icon"
                *ngIf="selectedJobType === 'Contract'"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Contract
            </div>
          </div>
        </div>

        <!-- Custom Dropdown 3: Location -->
        <div class="custom-dropdown-container">
          <button
            class="custom-dropdown-toggle-btn"
            (click)="toggleLocationDropdown($event)"
          >
            <span class="btn-text-content"> {{ selectedJobLocation || "Work Mode" }}</span>
            <svg
              class="dropdown-chevron"
              [class.rotated]="isLocationDropdownOpen"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </button>

          <div
            class="custom-dropdown-menu"
            *ngIf="isLocationDropdownOpen"
            (click)="$event.stopPropagation()"
          >
            <div
              class="menu-option-item"
              [class.selected]="selectedJobLocation === ''"
              (click)="selectLocation('')"
            >
              <svg
                class="check-icon"
                *ngIf="selectedJobLocation === ''"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              All Mode
            </div>
            <div
              class="menu-option-item"
              [class.selected]="selectedJobLocation === 'Onsite'"
              (click)="selectLocation('Onsite')"
            >
              <svg
                class="check-icon"
                *ngIf="selectedJobLocation === 'Onsite'"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Onsite
            </div>
            <div
              class="menu-option-item"
              [class.selected]="selectedJobLocation === 'Remote'"
              (click)="selectLocation('Remote')"
            >
              <svg
                class="check-icon"
                *ngIf="selectedJobLocation === 'Remote'"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Remote
            </div>
            <div
              class="menu-option-item"
              [class.selected]="selectedJobLocation === 'Hybrid'"
              (click)="selectLocation('Hybrid')"
            >
              <svg
                class="check-icon"
                *ngIf="selectedJobLocation === 'Hybrid'"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Hybrid
            </div>
          </div>
        </div>

        <!-- Custom Dropdown 4: Visibility -->
        <div class="custom-dropdown-container">
          <button
            class="custom-dropdown-toggle-btn"
            (click)="toggleVisibilityDropdown($event)"
          >
            <span class="btn-text-content">
              {{
                selectedVisibility === true
                  ? "Visible on BeExpert"
                  : selectedVisibility === false
                    ? "Hidden from BeExpert"
                    : "All Visibility"
              }}
            </span>

            <svg
              class="dropdown-chevron"
              [class.rotated]="isVisibilityDropdownOpen"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </button>

          <div
            class="custom-dropdown-menu"
            *ngIf="isVisibilityDropdownOpen"
            (click)="$event.stopPropagation()"
          >
            <!-- All -->
            <div
              class="menu-option-item"
              [class.selected]="selectedVisibility === null"
              (click)="selectVisibility(null)"
            >
              <svg
                class="check-icon"
                *ngIf="selectedVisibility === null"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              All Visibility
            </div>

            <!-- Visible -->
            <div
              class="menu-option-item"
              [class.selected]="selectedVisibility === true"
              (click)="selectVisibility(true)"
            >
              <svg
                class="check-icon"
                *ngIf="selectedVisibility === true"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Visible on BeExpert.ai
            </div>

            <div
              class="menu-option-item"
              [class.selected]="selectedVisibility === false"
              (click)="selectVisibility(false)"
            >
              <svg
                class="check-icon"
                *ngIf="selectedVisibility === false"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Hidden from BeExpert.ai
            </div>
          </div>
        </div>

        <!-- Toggle View Icon Buttons -->
        <div class="view-toggles">
          <button
            class="toggle-view-btn"
            [class.active]="isGridView"
            (click)="isGridView = true"
            title="Grid View"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="3" width="7" height="7" />
              <rect x="14" y="3" width="7" height="7" />
              <rect x="14" y="14" width="7" height="7" />
              <rect x="3" y="14" width="7" height="7" />
            </svg>
          </button>
          <button
            class="toggle-view-btn"
            [class.active]="!isGridView"
            (click)="isGridView = false"
            title="List View"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="4" y1="6" x2="20" y2="6" />
              <line x1="4" y1="12" x2="20" y2="12" />
              <line x1="4" y1="18" x2="20" y2="18" />
            </svg>
          </button>
        </div>
      </div>
    </div>

  <ng-container *ngIf="isLoading; else jobsContent">
    <div class="app-spinner">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
  </ng-container>

  <ng-template #jobsContent>
    <ng-container *ngIf="allPostJobs.length > 0; else showMessage">
    <div class="jobs-layout-grid" *ngIf="isGridView">
      <div class="job-card-v4" *ngFor="let job of allPostJobs">
        <div class="job-card-inner">
          <div class="job-card-header-row">
            <div class="card-header-left">
              <div
                class="category-icon-box"
                [ngClass]="{
                  'bg-purple':
                    job.department === 'Engineering' ||
                    job.department === 'Data Science',
                  'bg-green': job.department === 'Operations',
                  'bg-orange': job.department === 'Marketing',
                  'bg-pink': job.department === 'Design',
                }"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
                  <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                </svg>
              </div>
              <div class="title-meta">
                <h3 class="job-title-h3" [matTooltip]="job.job_title">{{ truncateText(job.job_title, 25) }}</h3>
                <span class="job-dept-span" [matTooltip]="job.job_role_category">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                    <line x1="8" y1="12" x2="16" y2="12" />
                  </svg>
                  {{ truncateText(job.job_role_category, 25) || '-' }}
                </span>
              </div>
            </div>

            <span
              class="status-pill-badge"
              [ngClass]="{
                'status-active': job.status.toLowerCase() === 'active',
                'status-closed': job.status.toLowerCase() === 'closed',
                'status-pending': job.status.toLowerCase() === 'pending',
                'status-draft': job.status.toLowerCase() === 'draft',
                'status-reject': job.status.toLowerCase() === 'rejected',
              }"
            >
              {{ capitalize(job.status) }}
            </span>
          </div>

          <!-- Tag pills row (Job Type, Location) -->
          <div class="job-card-pills-row">
            <span class="tag-pill-item type-pill">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="4" y1="9" x2="20" y2="9" />
                <line x1="4" y1="15" x2="20" y2="15" />
                <line x1="10" y1="3" x2="8" y2="21" />
                <line x1="16" y1="3" x2="14" y2="21" />
              </svg>
              {{ job.job_type || '-' }}
            </span>

            <span class="tag-pill-item type-pill">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="4" y1="9" x2="20" y2="9" />
                <line x1="4" y1="15" x2="20" y2="15" />
                <line x1="10" y1="3" x2="8" y2="21" />
                <line x1="16" y1="3" x2="14" y2="21" />
              </svg>
              {{ job.work_mode || '-'}}
            </span>

            <!--<span
              class="tag-pill-item location-pill"
              *ngFor="let location of job.locations"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              {{ location }}
            </span>-->

            <span
              *ngIf="job.is_visible_on_student_dashboard"
              class="visibility-status-badge visible-badge"
            >
              <i class="bi bi-eye-fill"></i>
              On BeExpert.ai
            </span>
          </div>

          <hr class="card-divider-line" />

          <!-- Applications and Deadline Stats -->
          <div class="stats-row-columns">
            <div class="stat-col">
              <span class="stat-col-lbl">OPENINGS</span>
              <span class="stat-col-val">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                </svg>
                {{ job.number_of_openings || '-' }}
              </span>
            </div>

            <div class="stat-col">
              <span class="stat-col-lbl">DEADLINE</span>
              <span class="stat-col-val highlight-deadline">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                {{ (job.application_deadline | date: "dd MMM yyy") || '-' }}
              </span>
            </div>
          </div>

          <!-- Action buttons -->
          <div class="card-action-buttons-wrapper">
            <button
              class="btn-card-footer-action btn-view"
              (click)="viewJobDetail(job.job_id)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="action-eye-icon"
              >
                <path
                  d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0z"
                />
                <circle cx="12" cy="12" r="3" />
              </svg>
              View Details
            </button>
            <button
              *ngIf="isJobDeletable(job.status)"
              class="btn-card-footer-action btn-delete"
              (click)="deleteJob(job.job_id, $event)"
              title="Delete Job"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M3 6h18"></path>
                <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="grid-card" *ngIf="!isGridView">
      <div class="table-container">
        <table class="data-table-v4">
          <thead>
            <tr>
              <th>Job Title</th>
              <th>Type</th>
              <th>Openings</th>
              <th>Status</th>
              <th>Deadline</th>
              <th class="actions-header">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let job of allPostJobs">
              <td class="font-bold-title" [matTooltip]="job.job_title">{{ truncateText(job.job_title, 25) || '-' }}</td>
              <td class="type-cell-text" [matTooltip]="job.job_role_category">{{ truncateText(job.job_role_category, 25) || '-' }}</td>
              <td class="applications-count-cell">
                {{ job.number_of_openings || '0' }}
              </td>
              <td>
                <span
                  class="status-pill-badge"
                  [ngClass]="{
                    'status-active': job.status.toLowerCase() === 'active',
                    'status-closed': job.status.toLowerCase() === 'closed',
                    'status-pending': job.status.toLowerCase() === 'pending',
                    'status-draft': job.status.toLowerCase() === 'draft',
                    'status-reject': job.status.toLowerCase() === 'rejected',
                  }"
                  >{{ job.status }}</span
                >
              </td>
              <td class="deadline-cell-text">
                {{ (job.application_deadline | date: "dd MMM yyy") || '-' }}
              </td>
              <td class="actions-cell">
                <div class="list-action-buttons-wrapper">
                  <button
                    class="list-action-btn"
                    (click)="viewJobDetail(job.job_id)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0z"
                      />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                    View
                  </button>
                  <button
                    *ngIf="isJobDeletable(job.status)"
                    class="list-action-btn btn-delete"
                    (click)="deleteJob(job.job_id, $event)"
                    title="Delete Job"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M3 6h18"></path>
                      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="allPostJobs.length === 0">
              <td colspan="6" class="empty-state-cell">
                No jobs matched the selected filters.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="table-pagination-footer" *ngIf="total > 0">
      <span class="showing-count-text"
        >Showing {{ (page - 1) * limit + 1 }}-{{
          getMathMin(page * limit, total)
        }}
        of {{ total }}</span
      >

      <div class="pagination-controls-box">
        <button
          class="page-nav-arrow-btn"
          [disabled]="page === 1"
          (click)="prevPage()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m15 18-6-6 6-6" />
          </svg>
        </button>
        <button class="page-num-indicator active">{{ page }}</button>
        <button
          class="page-nav-arrow-btn"
          [disabled]="page >= totalPage"
          (click)="nextPage()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-template #showMessage>
    <div class="empty-state-wrapper">
      <ng-container *ngIf="!hasActiveFilters(); else noMatchingTemplate">
        <i class="bi bi-briefcase empty-icon"></i>
        <h3>No Job Openings Created Yet</h3>
        <p>
          Create a new job opening to begin sourcing, screening, and hiring
          candidates.
        </p>

        <button
          class="clear-filter-btn"
          (click)="navigateToCreateJob()"
          style="background-color: #3d348b; color: white; border: none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            style="margin-right: 8px"
          >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
          Create Job Opening
        </button>
      </ng-container>

      <ng-template #noMatchingTemplate>
        <i class="bi bi-search empty-icon"></i>
        <h3>No matching jobs found</h3>
        <p>Try changing filters or clear all filters to see available jobs.</p>

        <button class="clear-filter-btn" (click)="clearAllFilters()">
          <i class="bi bi-arrow-counterclockwise"></i>
          Clear Filters
        </button>
      </ng-template>
    </div>
  </ng-template>
</ng-template>
